import React, { ChangeEvent, FormEvent, forwardRef, useState } from 'react';
import Error from '../../assets/icons/error.svg';
import { ErrorMessage } from './error';

type Props = {
  type?: string;
  name: string;
  value: string;
  required?: boolean;
  placeholder?: string;
  label?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const TextInput = (props: Props): JSX.Element => {
  const [valid, setValidation] = useState<boolean | null>(null);
  const name = props.name.charAt(0).toUpperCase() + props.name.substring(1);

  const onInvalid = (): void => {
    setValidation(false);
  };

  const onInput = (event: FormEvent): void => {
    const target = event.target as HTMLFormElement;
    setValidation(target.validity.valid as boolean);
  };

  return (
    <div>
      <label htmlFor={props.name} className="form-label">
        {props.label || name}
      </label>
      <input
        id={props.name}
        type={props.type || 'text'}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        className={`form-control ${valid === false ? 'invalid' : ''}`}
        placeholder={props.placeholder || `Enter your ${props.name.toLowerCase()}`}
        required={props.required}
        onInvalid={onInvalid}
        onInput={onInput}
      />
      {valid === false && (
        <span className="gray-1 form-error-message">
          <img src={Error} alt="error" />
          <span>{name} is required</span>
        </span>
      )}
    </div>
  );
};

type Props2 = {
  name: string;
  value?: string;
  className?: string;
  label?: string;
  errors?: any;
};

type LabelProps = {
  name?: string;
  children: any;
  className?: string;
};

export const Label = (props: LabelProps): JSX.Element => {
  return <label htmlFor={props.name} className={`form-label ${props.className || ''}`}>{props.children}</label>;
};

export const TextInput2 = (className: string): any => forwardRef((props: Props2, ref: any): JSX.Element => {
  const { errors, ...otherProps } = props;
  const errorClassName = errors?.[otherProps.name] ? 'invalid' : '';
  const mergedProps = { id: otherProps.name, ...otherProps, className: `form-control ${errorClassName} ${className} ${otherProps.className || ''}` };
  return <>
    <input ref={ref} { ...mergedProps } />
    {errors?.[otherProps.name]?.message && <ErrorMessage>{errors[otherProps.name].message}</ErrorMessage>}
  </>;
});

type FieldGuideProps = {
  children: string;
};

export const FieldGuide = (props: FieldGuideProps): JSX.Element => {
  return <span className="field-guide">{props.children}</span>;
};

export const TextInputLarge = TextInput2('input-lg');
export const TextInputSmall = TextInput2('');
